import validate from "/home/circleci/project/node_modules/.pnpm/nuxt@3.16.2_@types+node@18.19.8_cac@7.0.0_db0@0.3.4_encoding@0.1.13_eslint@10.5.0_jiti@_e1f8dc1784592a518d888be9f9dda493/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/circleci/project/node_modules/.pnpm/nuxt@3.16.2_@types+node@18.19.8_cac@7.0.0_db0@0.3.4_encoding@0.1.13_eslint@10.5.0_jiti@_e1f8dc1784592a518d888be9f9dda493/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}